import type { AxiosRequestConfig } from "axios";
import { api } from "../../api/axios";

/**
 * Orval mutator for the generated chat client: every chat REST call goes
 * through the app's shared axios instance, so it gets the Bearer token and the
 * existing 401 → refresh-token → retry flow from src/api/axios.ts.
 */
export const chatRequest = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => api.request<T>({ ...config, ...options }).then((r) => r.data);
